import { Button } from "../components/Button";
import { TrustCallout } from "../components/TrustCallout";
import { useAdvanceSoon } from "../flow/useAdvanceSoon";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function FaithConfirmScreen() {
  const { answers, setChristian, next, goToStep } = useFlow();
  const t = useT();
  const advance = useAdvanceSoon(next);

  return (
    <>
      <div className="prompt screen-enter">
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("faith.eyebrow")}</div>
          <h1 className="screen-head__title">{t("faith.title")}</h1>
          <p className="screen-head__text">{t("faith.text")}</p>
        </header>
        <div className="stack">
          <button
            type="button"
            className={`choice-card${answers.isChristian === true ? " is-selected" : ""}`}
            onClick={() => {
              setChristian(true);
              advance();
            }}
            aria-pressed={answers.isChristian === true}
          >
            <strong>{t("faith.yesTitle")}</strong>
            {t("faith.yesBody") ? <span>{t("faith.yesBody")}</span> : null}
          </button>
          <button
            type="button"
            className={`choice-card${answers.isChristian === false ? " is-selected" : ""}`}
            onClick={() => setChristian(false)}
            aria-pressed={answers.isChristian === false}
          >
            <strong>{t("faith.noTitle")}</strong>
            {t("faith.noBody") ? <span>{t("faith.noBody")}</span> : null}
          </button>
          {answers.isChristian === false ? (
            <TrustCallout title={t("faith.respectTitle")}>{t("faith.respectBody")}</TrustCallout>
          ) : null}
        </div>
      </div>
      {answers.isChristian === false ? (
        <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            variant="ghost"
            onClick={() => {
              setChristian(null);
              goToStep("welcome");
            }}
          >
            {t("common.leave")}
          </Button>
        </div>
      ) : null}
    </>
  );
}
